import { CalendarSearch } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { specialityMatchesQuery } from '@virtual-care/isomorphic';
import { Loading } from '@virtual-care/ui';

import { useLanguage } from '../../../i18n/use-language.ts';
import SpecialtySelectionCard from '../../components/booking/specialty-selection-card';
import { ProfileCard } from '../../components/header';
import Header from '../../components/header/header';
import { useSetting } from '../../hooks/use-settings.tsx';
import { useSpecialities } from '../../hooks/useSpecialities.ts';

export default function BookSecondOpinionAppointment() {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const { t } = useTranslation();
  const { language } = useLanguage();

  const { data, isPending } = useSpecialities();
  const secondOpinionFee = useSetting('secondOpinionFee');

  if (isPending) return <Loading />;

  const filteredData =
    data?.records.filter((spec) =>
      specialityMatchesQuery(spec, language, searchQuery),
    ) || [];

  return (
    <>
      <Header
        title={
          <div className="flex items-center gap-2">
            <div className="bg-sidebar-primary rounded-full p-2">
              <CalendarSearch className="h-6 w-6 text-white" />
            </div>
            <h1 className="text-base font-bold text-gray-900 md:text-2xl">
              {t('secondOpinion.pageTitle')}
            </h1>
          </div>
        }
      >
        <ProfileCard />
      </Header>
      <SpecialtySelectionCard
        fee={secondOpinionFee?.value}
        specialties={filteredData}
        selectedId={selectedId}
        onSelect={setSelectedId}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />
    </>
  );
}
